module.exports = __webpack_public_path__ + "media/images/icons/gf-mod-arrow_right-rounded-c8108832df3b3990cce6fcb7997f7721.svg";